<motn-subnav
  [items]="subnavItems"
></motn-subnav>

@if (childApp) {
  <div class="manage-users">
    <div class="users">
      <h3>
        Add/Remove Tenant Users
        <span
          class="button small yellow"
          [innerText]="childApp.Name"
        ></span>

        <button
          class="small green"
          (click)="addUser()"
        >
          <i class="far fa-plus"></i> Add User
        </button>
      </h3>

      <motn-sort-table
        [table$]="table$"
      ></motn-sort-table>
    </div>
  </div>
}
